import service from '@/utils/request'
// 查询询价单明细
export function inquiryDetailList(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetail/inquiryDetailList',
        data: param
    })
}
// 查询询价单明细 不分页
export function inquiryDetailListAll() {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetail/list',
    })
}
// 新增询价单明细
export function addInquiryDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetail/add',
        data: param
    })
}

// 新增轮次信息
export function addInquiryRound(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/add',
        data: param
    })
}
export function editInquiryRound(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/edit',
        data: param
    })
}

// 获取轮次信息
export function getInquiryRoundList(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/inquiryRoundList',
        data: param
    })
}


// 修改询价单明细
export function editInquiryDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetail/edit',
        data: param
    })
}

// 批量删除询价单明细
export function batchDelInquiryDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetail/batchDel',
        data: param
    })
}



// 删除询价单明细
export function delInquiryDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetail/del',
        data: param
    })
}
// 导出询价单明细
export function exportInquiryDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetail/export',
        data: param
    })
}
// 获取询价详情
export function getInquiryRoundDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/getInquiryRoundDetail',
        data: param
    })
}

// 获取订单的附件列表

export function queryInquiryAttachListByOrderId(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryAttach/queryInquiryAttachListByOrderId',
        data: param
    })
}

// 新增订单的附件
export function inquiryAttachAdd(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryAttach/add',
        data: param
    })
}

// 删除订单附件
export function inquiryAttachDel(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryAttach/del',
        data: param
    })
}

// 编辑订单的附件
export function inquiryAttachEdit(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryAttach/edit',
        data: param
    })
}

// 删除询价轮次
export function srmXjdelBid(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/del',
        data: param
    })
}

// 完结询价轮次
export function finishInquiryRound(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/finishInquiryRound',
        data: param
    })
}

// 发布询价轮次
export function publishInquiryRound(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/publishInquiryRound',
        data: param
    })
}

// 发布询价轮次
export function commodityById(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodity/commodityById',
        data: param
    })
}

// 新增评委
export function addJudgeSaveList(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryExpert/addSaveList',
        data: param
    })
}

// 新增评委
export function delJudge(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryExpert/del',
        data: param
    })
}

// 获取评委列表
export function getJudgeList(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryExpert/inquiryExpertList',
        data: param
    })
}

// 获取评委列表
export function updateBjList(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetailUser/updateList',
        data: param
    })
}

// 提交报价

export function submitOrderBj(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/submitOrder',
        data: param
    })
}

// 整单结束询价
export function finishOrderXj(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiry/finishOrderXj',
        data: param
    })
}

// 获取定标明细
export function getOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiry/getOrder',
        data: param
    })
}

// 开标
export function kaibiaoInquiryRound(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/kaibiaoInquiryRound',
        data: param
    })
}

// 上传定标数据
export function dingbiaoOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryDetailUser/dingbiaoOrder',
        data: param
    })
}

// 发起审批、审批
// auditStatus：2驳回，3通过    auditRemark:审批备注
export function auditOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiry/auditOrder',
        data: param
    })
}

// 获取审记录日志
export function getOrderAuditListByOrderId(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryApproval/getOrderAuditListByOrderId',
        data: param
    })
}

// 发送中标通知
export function zhongbiaoOrderNotice(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiry/zhongbiaoOrderNotice',
        data: param
    })
}

// 发送中标通知
export function generateFinalOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiry/generateFinalOrder',
        data: param
    })
}

// 采购员 获取订单列表
export function orderList(param) {
    return service.request({
        method: 'POST',
        url: '/app/order/orderList',
        data: param
    })
}

// 采购员 获取订单列表
export function orderMxList(param) {
    return service.request({
        method: 'POST',
        url: '/app/orderMx/orderMxList',
        data: param
    })
}

// 采购员 获取订单列表
export function getLastOrderState(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryApproval/getLastOrderState',
        data: param
    })
}

// 导出中标结果
export function exportWord(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiry/exportWord',
        data: param
    })
}

// 获取报价须知列表
export function inquiryNoteList(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryNote/inquiryNoteList',
        data: param
    })
}
// 新增报价须知
export function addInquiryNote(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryNote/add',
        data: param
    })
}
// 编辑报价须知
export function editInquiryNote(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryNote/edit',
        data: param
    })
}
// 删除报价须知
export function delInquiryNote(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryNote/del',
        data: param
    })
}

// 导出报价表
export function exportInquiryRoundDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryRound/exportInquiryRoundDetail',
        data: param,
        responseType: 'arraybuffer',
        downbinary:true
    })
}













